var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import colors from 'shared-assets/lib/colors';
import { InputGroup } from 'shared-assets/components/Form';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import Select from 'shared-assets/components/Elements/Select';
import StateSelect from 'shared-assets/components/StateSelect';
import styled from 'styled-components';
import PatientCaseDatesAndTypes from './PatientCaseDatesAndTypes';
var ConditionPanelWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-left : 20px;\n  label {\n    line-height: 2.0rem;\n  }\n  .conditionsDropdown {\n    width: 40%;\n    margin-left: 15px;\n  } \n"], ["\n  padding-left : 20px;\n  label {\n    line-height: 2.0rem;\n  }\n  .conditionsDropdown {\n    width: 40%;\n    margin-left: 15px;\n  } \n"])));
var EPSDT_REF_STATUS_DEFAULT_VALUE = 1;
var epsdtReferalStatus = [
    { name: 'Not used', code: 1 },
    { name: 'Available - not used', code: 2 },
    { name: 'Under treatment', code: 3 },
    { name: 'New Services Requested', code: 4 },
];
var ConditionPanel = function (props) {
    var _a = useState(''), selectedState = _a[0], selectedStateSetter = _a[1];
    var _b = useState(EPSDT_REF_STATUS_DEFAULT_VALUE), selectedEpsdtRefStatus = _b[0], selectedEpsdtRefStatusSetter = _b[1];
    var _c = useState(props.autoaccident), accidentFlag = _c[0], accidentSetter = _c[1];
    var _d = useState(props.employment), employmentFlag = _d[0], employmentSetter = _d[1];
    var _e = useState(false), noneFlag = _e[0], noneSetter = _e[1];
    var _f = useState(props.otheraccident), otherAccidentFlag = _f[0], otherAccidentSetter = _f[1];
    var _g = useState(props.pregnancy), pregnancyFlag = _g[0], pregnancySetter = _g[1];
    var _h = useState(props.epsdt), epsdtFlag = _h[0], epsdtSetter = _h[1];
    var _j = useState(props.familyplanning), familyplanningFlag = _j[0], familyplanningSetter = _j[1];
    var _k = useState(props.homebound), homeboundFlag = _k[0], homeboundSetter = _k[1];
    var _l = useState(props.emergency), emergencyFlag = _l[0], emergencySetter = _l[1];
    var _m = useState(props.validationFlag), validationFlag = _m[0], validationFlagSetter = _m[1];
    var _o = useState(false), isInvalidState = _o[0], isInvalidStateSetter = _o[1];
    var _p = useState(false), isInvalidEPSDT = _p[0], isInvalidEPSDTSetter = _p[1];
    var stateDropdownStyle = { width: '40%', marginLeft: '15px', borderColor: isInvalidState && colors.error };
    var epsdtDropdownStyle = { width: '40%', marginLeft: '15px', borderColor: isInvalidEPSDT && colors.error };
    var onPatientConditionChange = function (type) {
        switch (type) {
            case 'noneFlag':
                accidentSetter(false);
                employmentSetter(false);
                otherAccidentSetter(false);
                noneSetter(true);
                selectedStateSetter('');
                break;
            case 'accidentFlag':
                accidentSetter(true);
                employmentSetter(false);
                otherAccidentSetter(false);
                noneSetter(false);
                break;
            case 'employmentFlag':
                accidentSetter(false);
                employmentSetter(true);
                otherAccidentSetter(false);
                noneSetter(false);
                selectedStateSetter('');
                break;
            case 'otherAccidentFlag':
                accidentSetter(false);
                employmentSetter(false);
                otherAccidentSetter(true);
                noneSetter(false);
                selectedStateSetter('');
                break;
            default:
                break;
        }
    };
    var onEPSDTChange = function (checked) {
        epsdtSetter(checked);
        if (!checked) {
            selectedEpsdtRefStatusSetter(EPSDT_REF_STATUS_DEFAULT_VALUE);
        }
    };
    useEffect(function () {
        noneSetter(!props.autoaccident && !props.employment && !props.otheraccident);
        if (!!props.autoaccidentstate && !!props.autoaccidentstate.trim().length) {
            selectedStateSetter(props.autoaccidentstate);
        }
        selectedEpsdtRefStatusSetter(props.epsdtrefstatus);
        accidentSetter(props.autoaccident);
        employmentSetter(props.employment);
        otherAccidentSetter(props.otheraccident);
        pregnancySetter(props.pregnancy);
        epsdtSetter(props.epsdt);
        if (!props.epsdt) {
            selectedEpsdtRefStatusSetter(EPSDT_REF_STATUS_DEFAULT_VALUE);
        }
        familyplanningSetter(props.familyplanning);
        homeboundSetter(props.homebound);
        emergencySetter(props.emergency);
        validationFlagSetter(props.validationFlag);
    }, [props]);
    useEffect(function () {
        props.updatePatientCase.setConditions(accidentFlag, employmentFlag, otherAccidentFlag, noneFlag);
        isInvalidStateSetter(validationFlag && accidentFlag && !selectedState);
    }, [accidentFlag, employmentFlag, otherAccidentFlag, noneFlag, props.updatePatientCase, validationFlag, selectedState]);
    useEffect(function () {
        props.updatePatientCase.setAccidentState(selectedState);
    }, [selectedState, props.updatePatientCase]);
    useEffect(function () {
        props.updatePatientCase.setPregnancy(pregnancyFlag);
    }, [pregnancyFlag, props.updatePatientCase]);
    useEffect(function () {
        props.updatePatientCase.setEPSDT(epsdtFlag);
        isInvalidEPSDTSetter(validationFlag && epsdtFlag && (selectedEpsdtRefStatus === 0));
    }, [epsdtFlag, props.updatePatientCase, validationFlag, selectedEpsdtRefStatus]);
    useEffect(function () {
        props.updatePatientCase.setEPSDTid(selectedEpsdtRefStatus);
    }, [selectedEpsdtRefStatus, props.updatePatientCase]);
    useEffect(function () {
        props.updatePatientCase.setHomebound(homeboundFlag);
    }, [homeboundFlag, props.updatePatientCase]);
    useEffect(function () {
        props.updatePatientCase.setFamilyPlanning(familyplanningFlag);
    }, [familyplanningFlag, props.updatePatientCase]);
    useEffect(function () {
        props.updatePatientCase.setAnEmergency(emergencyFlag);
    }, [emergencyFlag, props.updatePatientCase]);
    return (React.createElement(ConditionPanelWrapper, null,
        React.createElement("div", { style: { paddingBottom: '16px' } },
            React.createElement("p", { style: { color: colors.secondary } },
                "The ",
                React.createElement("b", null, "patient condition"),
                " is related to:",
                ' '),
            React.createElement(InputGroup, { id: "radioNone", "data-testid": "none-radio-btn", type: "radio", name: "patientCondition", label: "None", checked: noneFlag, value: "noneFlag", onChange: function (e) { return onPatientConditionChange(e.target.value); }, style: { marginBottom: '5px' } }),
            React.createElement("div", { style: { display: 'flex', width: '60%', marginBottom: '2px', alignItems: 'center' } },
                React.createElement(InputGroup, { id: "autoaccident-radio-btn", "data-testid": "auto-accident-radio-btn", type: "radio", name: "patientCondition", label: "Auto Accident", checked: accidentFlag, value: "accidentFlag", onChange: function (e) { return onPatientConditionChange(e.target.value); } }),
                accidentFlag && (React.createElement(StateSelect, { className: 'conditionsDropdown', onChange: function (e) { return selectedStateSetter(e.target.value); }, value: selectedState, style: stateDropdownStyle, required: accidentFlag })),
                isInvalidState && React.createElement("p", { style: { color: colors.error, margin: '0', marginLeft: '15px' } }, " (required)")),
            React.createElement(InputGroup, { id: "radioEmployment", "data-testid": "employment-radio-btn", type: "radio", name: "patientCondition", label: "Employment", checked: employmentFlag, value: "employmentFlag", onChange: function (e) { return onPatientConditionChange(e.target.value); }, style: { marginBottom: '5px' } }),
            React.createElement(InputGroup, { id: "radioOther", "data-testid": "other-radio-btn", type: "radio", name: "patientCondition", label: "Other accident", checked: otherAccidentFlag, value: "otherAccidentFlag", onChange: function (e) { return onPatientConditionChange(e.target.value); }, style: { marginBottom: '5px' } })),
        React.createElement("div", null,
            React.createElement("p", { style: { color: colors.secondary } },
                "The ",
                React.createElement("b", null, "service provided"),
                " is related to:"),
            React.createElement(InputGroup, { id: "cbPregnancy", "data-testid": "pregnancy-checkbox", type: "checkbox", name: "serviceProvided", label: "Pregnancy", checked: pregnancyFlag, onChange: function (e) { return pregnancySetter(e.target.checked); }, style: { marginBottom: '10px' } }),
            React.createElement("div", { style: { display: 'flex', width: '60%', marginBottom: '10px', alignItems: 'center' } },
                React.createElement(InputGroup, { id: "cbEpsdt", "data-testid": "epsdt-checkbox", type: "checkbox", name: "serviceProvided", label: "EPSDT", checked: epsdtFlag, onChange: function (e) { return onEPSDTChange(e.target.checked); } }),
                epsdtFlag && (React.createElement(Select, { onChange: function (e) { return selectedEpsdtRefStatusSetter(e.target.value); }, style: epsdtDropdownStyle, value: selectedEpsdtRefStatus, required: epsdtFlag },
                    React.createElement("option", { disabled: true, value: "" }, "Select Referal Status"),
                    epsdtReferalStatus.map(function (refStatus) { return (React.createElement("option", { key: refStatus.code, value: refStatus.code }, refStatus.name)); }))),
                isInvalidEPSDT && React.createElement("p", { style: { color: colors.error, margin: '0', marginLeft: '15px' } }, " (required)")),
            React.createElement(InputGroup, { id: "cbFamilyPlanning", "data-testid": "family-planning-checkbox", type: "checkbox", name: "serviceProvided", label: "Family planning", checked: familyplanningFlag, onChange: function (e) { return familyplanningSetter(e.target.checked); }, style: { marginBottom: '10px' } }),
            React.createElement(InputGroup, { id: "cbHomebound", "data-testid": "homebound-checkbox", type: "checkbox", name: "serviceProvided", label: "Homebound", checked: homeboundFlag, onChange: function (e) { return homeboundSetter(e.target.checked); }, style: { marginBottom: '10px' } }),
            React.createElement(InputGroup, { id: "cbEmergency", "data-testid": "emergency-checkbox", type: "checkbox", name: "serviceProvided", label: "An emergency", checked: emergencyFlag, onChange: function (e) { return emergencySetter(e.target.checked); }, style: { marginBottom: '10px' } })),
        React.createElement(PatientCaseDatesAndTypes, { patientCaseId: props.patientCaseId, accidentFlag: accidentFlag, otheraccidentFlag: otherAccidentFlag, employmentFlag: employmentFlag, pregnancyFlag: pregnancyFlag, errorDates: props.errorDates, practiceId: props.practiceId, updatePatientCaseDates: props.updatePatientCaseDates, isNewCase: props.isNewCase })));
};
ConditionPanel.propTypes = {
    autoaccident: PropTypes.bool,
    autoaccidentstate: PropTypes.string,
    employment: PropTypes.bool,
    otheraccident: PropTypes.bool,
    pregnancy: PropTypes.bool,
    emergency: PropTypes.bool,
    homebound: PropTypes.bool,
    familyplanning: PropTypes.bool,
    epsdt: PropTypes.bool,
    epsdtrefstatus: PropTypes.number,
    patientCaseId: PropTypes.number,
    practiceId: PropTypes.number,
    validationFlag: PropTypes.bool,
    isNewCase: PropTypes.bool,
    updatePatientCase: PropTypes.shape({
        setConditions: PropTypes.func,
        setAccidentState: PropTypes.func,
        setPregnancy: PropTypes.func,
        setEPSDT: PropTypes.func,
        setEPSDTid: PropTypes.func,
        setHomebound: PropTypes.func,
        setFamilyPlanning: PropTypes.func,
        setAnEmergency: PropTypes.func,
    }),
    updatePatientCaseDates: PropTypes.shape({
        setPatientCaseDatesAndTypes: PropTypes.func,
        setDatePickerErrors: PropTypes.func,
    }),
    errorDates: PropTypes.arrayOf(PropTypes.shape({
        dateId: PropTypes.number,
        dateTypeError: PropTypes.bool,
    })),
};
ConditionPanel.defaultProps = {
    autoaccident: false,
    autoaccidentstate: '',
    employment: false,
    otheraccident: false,
    pregnancy: false,
    emergency: false,
    homebound: false,
    familyplanning: false,
    epsdt: false,
    patientCaseId: 0,
    practiceId: 0,
    epsdtrefstatus: EPSDT_REF_STATUS_DEFAULT_VALUE,
    validationFlag: false,
    isNewCase: false,
    updatePatientCase: {
        setConditions: function () { },
        setAccidentState: function () { },
        setPregnancy: function () { },
        setEPSDT: function () { },
        setEPSDTid: function () { },
        setHomebound: function () { },
        setFamilyPlanning: function () { },
        setAnEmergency: function () { },
    },
    updatePatientCaseDates: {
        setPatientCaseDatesAndTypes: function () { },
    },
    errorDates: [],
};
export default ConditionPanel;
var templateObject_1;
